import { toast } from 'sonner';
import errorCode from './ErrorCode';
import errorRender from './ErrorRender';

export default function Index(error: any) {

  if (error?.response?.data?.statusCode) {
    if (errorCode(error?.response?.data?.statusCode)) {
      if (error?.response?.data.errors) {
        errorRender(error);
      } else {
        toast.error(error?.response?.data?.message);
        return;
      }
    } else {
      toast.error(error?.response?.data?.message);
      return;
    }
  } else {
    if (
      error.message !== "Cannot read properties of undefined (reading 'fileId')"
    ) {
      if (error.message !== 'call: argument fn is undefined or null') {
        if (error.message !== 'Content not exist error.') {
          if (error.message !== 'e is undefined') {
            if (
              error.message !==
              'call: argument of type {context, fn} has undefined or null `fn`'
            ) {
              if (error.message !== 'mime.getType is not a function') {
                if (
                  error.message !==
                  "undefined is not an object (evaluating 'e.context')"
                ) {
                  if (
                    error.message !==
                    "Cannot read properties of undefined (reading 'context')"
                  ) {
                    if (
                      error.message !==
                      "Cannot read properties of undefined (reading '0')"
                    ) {
                      if (
                        error.message !==
                        'call: argument fn is undefined or null'
                      ) {
                        if (
                          error.message !==
                          "Cannot read properties of undefined (reading 'results')"
                        ) {
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
